import { Alert, Drawer } from 'antd'
import React, { useState } from 'react'
import DeviceDetailsList from './DeviceDetailsList'
import MoreInfoModal from 'components/MoreInfoModal'
import propTypes from 'global/propTypes'
import PropTypes from 'prop-types'
import { QuestionCircleOutlined } from '@ant-design/icons'
import Text from 'components/Text'
import { useTranslation } from 'react-i18next'

import './deviceDetailsDrawer.less'

const DeviceDetailsDrawer = ({
  devices,
  error,
  isOpen,
  isUnlockingDeviceId,
  onClearError,
  onClose,
  onUnlock,
}) => {
  const { t } = useTranslation()
  const [showMoreInfoModal, setShowMoreInfoModal] = useState(false)

  const openMoreInfoModal = () => setShowMoreInfoModal(true)
  const closeMoreInfoModal = () => setShowMoreInfoModal(false)
  const isBusy = !!isUnlockingDeviceId

  const handleClose = () => {
    if (onClearError) {
      onClearError()
    }

    onClose()
  }

  return (
    <>
      <Drawer
        closable={!isBusy}
        maskClosable={!isBusy}
        onClose={isBusy ? undefined : handleClose}
        open={isOpen}
        placement="right"
        size="large"
        title={
          <div className="device-details-drawer__title">
            <Text className="device-details-drawer__title-text">
              {t('portCall.shipOverview.deviceDetails')}
            </Text>

            <QuestionCircleOutlined
              className="device-details-drawer__help"
              onClick={openMoreInfoModal}
            />
          </div>
        }
      >
        <div className="device-details-drawer__content">
          {error && (
            <Alert
              banner
              className="device-details-drawer__error"
              message={t(error)}
              showIcon
              type="error"
            />
          )}

          <DeviceDetailsList
            devices={devices}
            isUnlockingDeviceId={isUnlockingDeviceId}
            onUnlock={onUnlock}
          />
        </div>
      </Drawer>

      {showMoreInfoModal && (
        <MoreInfoModal
          isVisible={showMoreInfoModal}
          onClose={closeMoreInfoModal}
          title={t('portCall.shipOverview.deviceDetails')}
        >
          <div>
            <Text>
              {t('portCall.shipOverview.deviceDetailsInfo.description')}
            </Text>
          </div>
        </MoreInfoModal>
      )}
    </>
  )
}

DeviceDetailsDrawer.defaultProps = {
  error: null,
  isUnlockingDeviceId: null,
}

DeviceDetailsDrawer.propTypes = {
  devices: PropTypes.arrayOf(propTypes.shipOverviewDevice).isRequired,
  error: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  isUnlockingDeviceId: PropTypes.string,
  onClearError: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onUnlock: PropTypes.func.isRequired,
}

export default DeviceDetailsDrawer
